import React from 'react'

export const NotFound = () => {
	return (
		<div className="d-flex justify-content-center align-items-center not-found">
			<h1 className="d-flex flex-column align-items-center"><p>404</p> NOT FOUND</h1>
    </div>
	)
}